import ApiHelper from '../ApiHelper.js';

const ReviewApiUrl = "/api/review/";

export default {
    getReviewsByContentId: function (contentId) {
        return ApiHelper.get(ReviewApiUrl  + contentId);
    },
}
